import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import PropTypes from 'prop-types';
import { isLastNPeriodLabel } from '../../../../common/services/textService';
import AdjustmentControlsColumn from './AdjustmentControlsColumn';
import FinancialSpacer from './FinancialSpacer';

const FinalBorderRow = ({ timePeriods, documentCode, isPublishMode }) => {
  const isNwcTable = documentCode === Constants.NET_WORKING_CAPITAL;

  return (
    <tr role="row" className="final-border-row">
      <td className="row-description final-row" />

      {timePeriods.map((timePeriod) => {
        const isLastNPeriod = isLastNPeriodLabel(timePeriod);
        const showColumnHighlight = isNwcTable && isLastNPeriod;

        return (
          <FinancialSpacer
            showColumnHighlight={showColumnHighlight}
            key={timePeriod}
          />
        );
      })}
      {!isPublishMode && <AdjustmentControlsColumn />}
    </tr>
  );
};

export default FinalBorderRow;

FinalBorderRow.propTypes = {
  timePeriods: PropTypes.arrayOf(PropTypes.string).isRequired,
  documentCode: PropTypes.string,
  isPublishMode: PropTypes.bool,
};

FinalBorderRow.defaultProps = {
  documentCode: '',
  isPublishMode: false,
};
